import React, { useState } from "react"
import { Button, Checkbox, Form, notification } from "antd"

import APIService from "../../services/api"
import StorageService from "../../services/storage"

const EHR = ({ id, data }) => {
  const { ehrConfig } = data
  const [form] = Form.useForm()
  const [wrapAround, setWrapAround] = useState(
    ehrConfig?.wrapAround ? ehrConfig?.wrapAround : false
  )

  const openNotification = () => {
    notification.open({
      message: "Updated Successfully",
    })
  }
  const onFinish = () => {
    form
      .validateFields()
      .then(async () => {
        console.log(wrapAround)
        let userData = StorageService.getData("user")
        let requestObj = {
          userId: userData?._id,
          organizationId: id,
          organizationName: data?.name,
          organizationType: data?.organizationType,
          ehrConfig: {
            wrapAround: wrapAround,
          },
        }
        const response = await APIService.requestWithToken(
          "api/v1/organization/addOrEditOrganization",
          "post",
          requestObj
        )

        if (
          response?.res?.message.includes("organization update successfully.")
        ) {
          openNotification()
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const onChange = (e) => {
    setWrapAround(e.target.checked)
  }

  return (
    <>
      <Form
        form={form}
        initialValues={data}
        name="control-hooks"
        layout="vertical"
        onFinish={onFinish}
      >
        <Form.Item name="name" label="" rules={[{ required: true }]}>
          <Checkbox checked={wrapAround} onChange={onChange}>
            Wrap Around
          </Checkbox>
        </Form.Item>
        <Form.Item
          wrapperCol={{
            offset: 11,
            span: 16,
          }}
        >
          <div>
            <Button type="primary" htmlType="submit">
              Save
            </Button>
          </div>
        </Form.Item>
      </Form>
    </>
  )
}

export default EHR
